import * as React from "react";
import { Outlet } from "react-router";
import MainLayout from "../../../components/atoms/MainLayout";
import { withRouter } from "../../../helpers/RouterHelper";
import enhanceAuthenticatedPage, {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
} from "../../../hocs/enhanceAuthenticatedPage";
import withErrorPages from "../../../hocs/withErrorPages";
import SectionGlobalHeader from "../../SectionGlobalHeader";
import SectionSidebar from "../../SectionSidebar";

type Props = AuthenticatedPageProps & AuthenticatedPageCallbacks;

const SectionLayout = (props: Props) => {
  const [activeMenu, setActiveMenu] = React.useState<string>("");

  return (
    <MainLayout>
      <SectionSidebar {...props} activeMenu={activeMenu} />
      <SectionGlobalHeader {...props} />
      <Outlet context={{ setActiveMenu }} />
    </MainLayout>
  );
};

export default withRouter(
  withErrorPages(enhanceAuthenticatedPage(SectionLayout)),
);
